// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import AppSelectSvg from '@rsuite/icon-font/lib/action/AppSelect';
var AppSelect = createSvgIcon({
  as: AppSelectSvg,
  ariaLabel: 'app select',
  category: 'action',
  displayName: 'AppSelect'
});
export default AppSelect;